import React from "react";
import { Outlet, useOutlet } from "react-router-dom";
import { AdminSideBar } from "../admin-sidebar/AdminSidebar";
import "./Admin.main.css";
import { AdminHeader } from "../admin-header/Admin.header";
import { ToastContainer } from "react-toastify";
import Footer from "../../../shared/layout/footer/footer";
const AdminMain = () => {
  const outlet = useOutlet();
  return (
    <React.Fragment>
      <div className="site-wrappers">
        <div className="top-wraps">
          <AdminHeader></AdminHeader>
          <AdminSideBar></AdminSideBar>
          <div className="body-section">
            <div className="content">{outlet}</div>
          </div>
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </React.Fragment>
  );
};
export { AdminMain };
